import React from 'react';
import './PromoBanner.css';

import snackImg from '../components/assets/images/shilajit-5.png'; 
import fruitsImg from '../components/assets/images/Shilajit-7.png'; 


const PromoBanner = () => {
  return (
    <div className="promo-banner-container">
      <div className="promo-box">
        <img src={snackImg} alt="Tasty Snack" className="promo-img" />
        <div className="promo-text">
          <h2>Shilajit Pure,Safe & Authentic</h2>
          <p>Shilajit You Can Trust – Pure, Safe, Lab-Tested, Authentic.</p>
          <br />
          <a href="/shilajit" className="promo-btn">
          Shop Now &raquo;
            </a>
        </div>
      </div>

      <div className="promo-box">       
        <div className="promo-text">
          <h2>Combo Shilajit</h2>
          <p>Natural Shilajit boosts stamina, energy, strength, focus, and immunity.</p>
         <br />
          <a href="/combo" className="promo-btn">
          Shop Now &raquo;
            </a>
        </div>
        <img src={fruitsImg} alt="Fresh Fruits" className="promo-img" />
      </div>
    </div>
  );
};

export default PromoBanner;
